module.exports = __webpack_public_path__ + "img/Rusk_UK.a29c2011.jpg";